import { CourseSubjectPriceState, CourseSubjectState } from './../../../../../../../features/types'
import { CoursePriceState } from '../../../../../../../features/types'

interface PriceState {
    courseSubjectsPrice: CourseSubjectPriceState[]
}

const getCoursePrice = (editCoursePrice: CoursePriceState): CoursePriceState => {
    const coursePrice: CoursePriceState = {
        id: editCoursePrice?.id ?? null,
        titleKz: editCoursePrice?.titleKz ?? '',
        titleRu: editCoursePrice?.titleRu ?? '',
        sloganKz: editCoursePrice?.sloganKz ?? '',
        sloganRu: editCoursePrice?.sloganRu ?? '',
        courseId: editCoursePrice?.courseId ?? null,
        price: editCoursePrice?.price ?? null,
        optimalPrice: editCoursePrice?.optimalPrice ?? null,
        duration: editCoursePrice?.duration ?? null,
        requiredSubjectCount: editCoursePrice?.requiredSubjectCount ?? null,
        notRequiredSubjectCount: editCoursePrice?.notRequiredSubjectCount ?? null,
        requiredSubjectsMandatory: editCoursePrice?.requiredSubjectsMandatory ?? false,
        isMonthly: editCoursePrice?.isMonthly ?? false,
    }

    return coursePrice
}

const getCourseSubjectsPrice = (
    _undefined,
    coursePriceId: number,
    courseSubjectsPrice: CourseSubjectPriceState[],
    courseSubjects: CourseSubjectState[],
): PriceState => {
    const courseSubjectPrice: CourseSubjectPriceState = {
        sloganKz: '',
        sloganRu: '',
        courseSubjectId: null,
        coursePriceId: null,
        singleTopicPrice: null,
        price: null,
        isActive: false,
    }

    if (courseSubjectsPrice.length) {
        const mappedCourseSubjectsPrice = courseSubjects.map((courseSubject) => {
            const currentCourseSubjectPrice = courseSubjectsPrice.find(
                (price) => price.courseSubjectId === courseSubject.id,
            )

            if (currentCourseSubjectPrice) {
                return { ...currentCourseSubjectPrice }
            }

            return {
                ...courseSubjectPrice,
                courseSubjectId: courseSubject.id,
                coursePriceId,
            }
        })

        return { courseSubjectsPrice: mappedCourseSubjectsPrice }
    }

    const newCourseSubjectsPrice = courseSubjects.map((courseSubject) => {
        return {
            ...courseSubjectPrice,
            courseSubjectId: courseSubject.id,
            coursePriceId,
        }
    })

    return { courseSubjectsPrice: newCourseSubjectsPrice }
}

export default [getCoursePrice, getCourseSubjectsPrice]
